<template>
  <nav class="gs-portal-rail" aria-label="Promo sections">
    <button
      v-for="item in items"
      :key="item.value"
      type="button"
      class="gs-portal-rail__item"
      :class="{ 'is-current': item.value === current }"
      :data-section="item.value"
      :aria-current="item.value === current ? 'true' : null"
      @click="select(item.value)"
    >
      <gs-icon class="gs-portal-rail__icon" :name="item.icon" size="16" />
      <span class="gs-portal-rail__label">{{ item.label }}</span>
      <gs-icon
        v-if="item.completed"
        class="gs-portal-rail__done"
        name="check"
        size="14"
        aria-label="Done"
      />
    </button>
  </nav>
</template>

<script>
export default {
  name: 'SectionRail',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    current: {
      type: String,
      default: '',
    },
  },
  methods: {
    select(value) {
      this.$emit('select', value);
    },
  },
};
</script>

<style scoped>
.gs-portal-rail {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding: 8px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-portal-rail__item {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 9px 12px;
  color: var(--gs-foreground);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  background: transparent;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: var(--gs-radius-md);
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
}

.gs-portal-rail__item:hover {
  background: var(--gs-muted);
}

.gs-portal-rail__item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--gs-ring);
}

.gs-portal-rail__item.is-current {
  color: var(--gs-primary);
  font-weight: 700;
  background: var(--gs-primary-soft);
  border-left-color: var(--gs-primary);
  border-radius: 0 var(--gs-radius-md) var(--gs-radius-md) 0;
}

.gs-portal-rail__icon {
  flex: none;
  color: var(--gs-muted-foreground);
}

.gs-portal-rail__item.is-current .gs-portal-rail__icon {
  color: var(--gs-primary);
}

.gs-portal-rail__label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: normal;
  line-height: 1.4;
  text-overflow: ellipsis;
}

.gs-portal-rail__done {
  flex: none;
  color: var(--gs-success);
}

/* Below the two-column breakpoint the rail becomes a horizontal chip strip
   that scrolls sideways, so the widget stays usable down to 360px. */
@media (max-width: 899px) {
  .gs-portal-rail {
    flex-direction: row;
    gap: 8px;
    overflow-x: auto;
    padding: 8px 10px;
    -webkit-overflow-scrolling: touch;
  }

  .gs-portal-rail__item {
    flex: none;
    width: auto;
    padding: 7px 12px;
    font-size: 13px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: 999px;
  }

  .gs-portal-rail__item.is-current {
    background: var(--gs-primary-soft);
    border-color: var(--gs-primary);
    border-radius: 999px;
  }

  .gs-portal-rail__label {
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
  }
}
</style>
